import { FC } from 'react';

import { LineChartData, XAxis, YAxis } from 'src/components/LineChart/types';
import { getAreaPath } from 'src/components/LineChart/utils';

const COLOR = '#f9f9f9';

interface HatchingAreaProps {
    data: LineChartData;
    xAxis: XAxis;
    yAxis: YAxis;
    yMinValue: number;
}

const HatchingArea: FC<HatchingAreaProps> = ({ data, xAxis, yAxis, yMinValue }) => {
    const areaPath = getAreaPath(data, xAxis, yAxis, yMinValue);

    if (!areaPath) {
        return null;
    }

    return <path fill={COLOR} stroke="none" d={areaPath} />;
};

export default HatchingArea;
